export default "__VITE_ASSET__e6a81e87__"